export default __webpack_public_path__ + "static/media/supanniga.41cff118.jpeg";